import Advantages from "@/app/components/ServicesComponents/ConsorcioComponents/Advantages";
import InfoCards from "@/app/components/ServicesComponents/ConsorcioComponents/InfoCards";
import ProcessSteps from "@/app/components/ServicesComponents/ConsorcioComponents/ProcessSteps";
import React from "react";
import { withServicesLayout } from "@/pages/_layoutService";

function ConsorcioToyota() {
  return (
    <div className="w-full text-zinc-800 p-3">
      <h1 className="text-5xl  text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
        Consórcio Toyota
      </h1>
      <div className="w-16 border-b-2 ml-1 border-red-600 " />
      <p className="flex flex-col mt-4 w-full text-2xl leading-7 text-zinc-600 max-md:max-w-full">
        Ficou muito fácil fazer uma plano para trocar ou comprar seu carro.
      </p>
      <ProcessSteps />
      <InfoCards />
      <Advantages />
    </div>
  );
}

export default withServicesLayout(ConsorcioToyota);
export { getServerSideProps } from "@/pages/_layoutService";
